import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  redirectTo?: string;
}

/**
 * Component that restricts access to SST (Strategic Sourcing Team) role only.
 * Redirects unauthorized users to dashboard (home page) by default.
 */
export const AdminGuard: React.FC<AdminGuardProps> = ({ 
  children, 
  fallback, 
  redirectTo = '/dashboard' 
}) => {
  const { user } = useAuth();
  
  // Check if user has SST role (Member user type with memberRole SST)
  const isSST = user?.userType === 'Member' && user?.memberRole === 'SST';
  
  if (!isSST) {
    // If fallback is provided, use it; otherwise redirect to home/dashboard
    return fallback || <Navigate to={redirectTo} replace />;
  }
  
  return <>{children}</>;
};

export default AdminGuard;
